import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { CashTab } from '@/App/UserPreferences/CashTab/index.tsx';
import { GeneralTab } from '@/App/UserPreferences/GeneralTab/index.tsx';
import { NotificationsTab } from '@/App/UserPreferences/Notifications/index.tsx';
import { OptionTab } from '@/App/UserPreferences/OptionTab/index.tsx';
import { UserPreferencesNavBar, type UserPrefTab } from '@/App/UserPreferences/UserPreferencesTabs.tsx';

type UserPreferencesModalProps = {
  show: boolean;
  handleClose: () => void;
};

const UserPreferencesModal = ({ handleClose, show }: UserPreferencesModalProps) => {
  const [tabSelected, setTabSelected] = useState<UserPrefTab>('general');
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleTabClick = (tab: UserPrefTab) => {
    sgwtWebAnalytics?.trackEvent('Header', 'select user preferences tab', tab);
    setTabSelected(tab);
  };

  return (
    <Modal show={show} size="lg" onHide={handleClose} data-e2e="user-preference-modal">
      <div className="d-flex border shadow-max" style={{ maxHeight: '80vh' }}>
        {/* Left side menu */}
        <UserPreferencesNavBar tabSelected={tabSelected} handleTabClick={handleTabClick} />

        {/* Right side content */}
        <div className="d-flex flex-column flex-grow-1">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="p-2 px-lg-4 py-lg-3 mt-1 mb-3">
              <FormattedMessage id={`userPreferences.tab.${tabSelected}`} />
            </h5>
            <button
              type="button"
              className="btn btn-discreet btn-icon btn-flat-primary me-3 position-relative"
              style={{ left: '8px' }}
              data-e2e="close-user-preference-btn"
              onClick={handleClose}
            >
              <span className="icon">close</span>
            </button>
          </div>

          <div className="px-4 py-3">
            {tabSelected === 'general' && <GeneralTab />}
            {tabSelected === 'cash' && <CashTab />}
            {tabSelected === 'option' && <OptionTab />}
            {tabSelected === 'notifications' && <NotificationsTab />}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default UserPreferencesModal;
